import MyStartups from '@/views/ecosystem/MyStartups'
import Portfolios from '@/views/ecosystem/Portfolios'
import Portfolio from '@/views/Portfolio'
import Connections from '@/views/ecosystem/Connections'
import Enterprises from '@/views/ecosystem/Enterprises'
import Trackers from "@/views/ecosystem/Trackers";
import Tracker from "@/views/ecosystem/Tracker";

export default [
    {
        path: '/my-startups',
        component: MyStartups,
        meta: {
            access: ['ecosystem']
        }
    },
    {
        path: '/my-startups/portfolios',
        component: Portfolios,
        meta: {
            access: ['ecosystem']
        }
    },
    {
        path: '/my-startups/portfolios/:id',
        component: Portfolio,
        meta: {
            access: ['ecosystem','enterprise']
        }
    },
    {
        path: '/connections',
        component: Connections,
        meta: {
            access: ['ecosystem']
        }
    },
    {
        path: '/connections/enterprises',
        component: Enterprises,
        meta: {
            access: ['ecosystem']
        }
    },
    {
        path: '/projects/:id',
        component: Tracker,
        meta: {
            access: ['ecosystem']
        }
    },
    {
        path: '/projects',
        component: Trackers,
        meta: {
            access: ['ecosystem']
        }
    },
]